module.exports = "/assets/site/images/promo-incentive.c15b90dc.png?c15b90dc";